import { Link } from "react-router-dom";
import serverDown from "./../assets/svg/server_down.svg";

function NotFound() {
    return (
        <div className="page-error">
            <div className="content">
                <div className="container">
                    <div className="row gx-5">
                        <div className="col-lg-5 d-flex flex-column align-items-center">
                            <h1 className="error-number">404</h1>
                            <h2 className="error-title">Page Not Found</h2>
                            <p className="error-text">Oopps. The page you were looking for doesn't exist. You may have mistyped the address or the page may have moved.</p>
                            <Link to="/" className="btn btn-primary btn-error">Back to Dashboard</Link>
                        </div>
                        <div className="col-8 col-lg-6 mb-5 mb-lg-0">
                            <object type="image/svg+xml" data={serverDown} className="w-100"></object>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default NotFound;